(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("solace", [], factory);
	else if(typeof exports === 'object')
		exports["solace"] = factory();
	else
		root["solace"] = factory();
})(this, () => {
return 